export default __webpack_public_path__ + "img/a5daceae83c834b02ca014546d7f3265.svg";